export default __webpack_public_path__ + "static/utility-73553b50235cc5b7726dcad8085f4fe7.png";